module.exports = __webpack_public_path__ + "static/media/fratelliSchiratti.2425d575.jpg";